var getButtonClasses = function (context) { return [
    'tw-relative',
    // Flex & Alignment
    'tw-inline-flex tw-items-center tw-justify-center',
    // Shape
    'tw-border-0 tw-rounded-xl',
    // Size
    'tw-min-w-8 tw-h-8',
    'tw-leading-none',
    // Color
    'tw-text-zinc-800 dark:tw-text-white/60',
    // State
    'hover:tw-bg-gray-200',
    {
        'focus:tw-outline-none focus:tw-outline-offset-0 focus:tw-ring focus:tw-ring-gray-300 dark:focus:tw-ring-gray-700': !context.disabled,
    },
    // Transition
    'tw-transition tw-duration-200',
    // Misc
    'tw-user-none tw-overflow-hidden',
    { 'tw-cursor-default tw-pointer-events-none tw-opacity-50': context.disabled },
]; };
export default {
    root: {
        class: [
            // Flex & Alignment
            'tw-flex tw-items-center tw-justify-center tw-flex-wrap',
            // Spacing
            'tw-px-2',
            // Shape
            'tw-border-0',
            // Color
            'tw-bg-gray-0 dark:tw-bg-gray-800',
            'tw-text-zinc-800 dark:tw-text-white/60',
        ],
    },
    content: {
        class: [
            // Flex & Alignment
            'tw-flex tw-items-center tw-justify-center tw-flex-wrap tw-gap-1',
        ],
    },
    first: function (_a) {
        var context = _a.context;
        return ({
            class: getButtonClasses(context),
        });
    },
    prev: function (_a) {
        var context = _a.context;
        return ({
            class: getButtonClasses(context),
        });
    },
    next: function (_a) {
        var context = _a.context;
        return ({
            class: getButtonClasses(context),
        });
    },
    last: function (_a) {
        var context = _a.context;
        return ({
            class: getButtonClasses(context),
        });
    },
    pages: 'tw-flex tw-items-center tw-gap-1',
    page: function (_a) {
        var context = _a.context;
        return ({
            class: [
                'tw-relative',
                // Flex & Alignment
                'tw-inline-flex tw-items-center tw-justify-center',
                // Shape
                'tw-border-0 tw-rounded-xl',
                // Size
                'tw-min-w-8 tw-h-8',
                'tw-leading-none',
                // State
                {
                    'tw-bg-primary-500 tw-text-white tw-drop-shadow': context.active,
                    'hover:tw-bg-gray-200': !context.active && !context.disabled,
                    'focus:tw-outline-none focus:tw-outline-offset-0 focus:tw-ring focus:tw-ring-primary-300 dark:focus:tw-ring-primary-700': !context.disabled,
                },
                // Transition
                'tw-transition tw-duration-200',
                // Misc
                'tw-user-none tw-overflow-hidden',
                { 'tw-cursor-default tw-pointer-events-none tw-opacity-50': context.disabled },
            ],
        });
    },
    contentStart: 'tw-mr-auto',
    contentEnd: 'tw-ml-auto',
    lastIcon: 'tw-size-4',
    firstIcon: 'tw-size-4',
    prevIcon: 'tw-size-4',
    nextIcon: 'tw-size-4',
};
